import { UserConstants } from '../constants';

let initialState = { driversBC: [], driversBCCreating: false, driversBCCreated: false, driversBCError: '' };
export function driversBC(state = initialState, action) {
    switch (action.type) {
    case UserConstants.DRIVERSBC_SUCCESS:
        return {
            driversBC: action.payload.data,
            driversBCCreated: true,
            driversBCCreating: false,
            driversBCError: '',
        };
    case UserConstants.DRIVERSBC_REQUEST:
        return {
            driversBC: [],
            driversBCCreating: true,
            driversBCCreated: false,
            driversBCError: '',
        };
    case UserConstants.DRIVERSBC_ERROR:
        return {
            driversBC: [],
            driversBCCreated: false,
            driversBCCreating: false,
            driversBCError: action.payload.message
        };
    default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/DriversByC.jsx